import { WheelOption } from '@interface/ruleta.interface';

export enum BonusType {
  BIENVENIDA = 'bono_de_bienvenida',
  ESCALONADO = 'bono_escalonado',
  PORCENTUAL = 'bono_porcentual',
  CDT_REGALO = 'bono_cdt_regalo',
  RULETA = 'bono_ruleta',
  YO_ME_LLAMO_CDT = 'yo_me_llamo_cdt',
  DIAS_AZULES = 'dias_azules',
  IAF_2026 = 'iaf_2026',
  MONEYCON_2026 = 'moneycon_2026'
}

export interface BonusConfig {
  type: BonusType;
  amount: number;
  valorCdtRegalo?: number;
  minTermDays?: number;
  termDays?: number;
  roulettePrize?: any; 
  blockInvalidTerms?: boolean; 
}

export interface BonusResult {
  isValid: boolean;
  bonusAmount: number;
  message?: string;
  confettiType: string;
  amountLocked?: boolean;
  lockedValue?: number;
  displayAmount?: string;
  bonusTag?: string;
  message_simulador?: string;
  minTermDays?: number[];
  tagNameBonusType?: string;
  termsAndConditionsUrl?: string;
  termsAndConditionsDescription?: string;
  roulettePrize?: WheelOption;
  blockInvalidTerms?: boolean;
  label?: string;
  value?: string;
  specialPrize?: boolean;
  keepPlaying?: boolean;
  messages?: {
    desktop: string;
    mobile: string;
  };
}

export interface AmountConstraints {
  locked: boolean;
  value?: number;
  minAmount?: number;
  maxAmount?: number;
}

export interface ConfettiConfig {
  type: string;
  duration: number;
  intensity: 'light' | 'medium' | 'heavy';
}

export interface BonusStrategy {
  type: BonusType;
  campaignSpecific: boolean; // Indica si es específico de una campaña (true) o genérico (false)
  validateAmount(amount: number, extraParams?: any): boolean;
  calculateBonus(amount: number, termDays: number, extraParams?: any): BonusResult;
  getConfettiConfig(): ConfettiConfig;
  getAmountConstraints(extraParams?: any): AmountConstraints;
  getTermsAndConditions(): { url: string; description: string };
}
